// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1_b3c","cls2":"NewsInteractionBar-cls2_JN_ NewsInteractionBar-cls1_b3c"};